<template>
  <div>
    <!-- <div class="contact-widget hidden-xs">
      <div class="consult_item"
      >
        <img src="../assets/images/homepage/qq.svg" width="36" style="margin-left: 5px"
            @mouseover="qqtoggleShow()"
            @mouseout="qqtoggleShow()"
        >
        <transition name="fade">
          <img src="../assets/images/homepage/qqgroup.png"
              v-show="qqisShow"
              class="qqgroup animated"
              >
        </transition>
        <img src="../assets/images/homepage/weixin.svg" width="36" style="margin-left:10px "
            @mouseover="weixintoggleShow()"
            @mouseout="weixintoggleShow()"
        >
        <transition name="fade">
          <img src="../assets/images/homepage/weixingroup.png"
              v-show="weixinisShow"
              class="weixingroup animated"
              >
        </transition>
      </div>
    </div> -->
    <div class="contact-widget-circle hidden-xs"   >
      <div class="consult_item">
         <img src="../assets/images/homepage/weixin.svg" class="mobileImg" width="32" style="margin-left:7px;margin-top:7px "
            @mouseover="weixintoggleShow()"
            @mouseout="weixintoggleShow()"
        >
        <transition name="fade">
          <img src="../assets/images/homepage/weixingroup.png"
              v-show="weixinisShow"
              class="weixingroup animated"
              >
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      qqisShow: false,
      weixinisShow: false,
      btnStyle: "Default",
      showChat: false
    };
  },
  methods: {
    qqtoggleShow: function() {
      this.qqisShow = !this.qqisShow;
    },
    weixintoggleShow: function() {
      this.weixinisShow = !this.weixinisShow;
    }
  },
  watch: {
    qqisShow: function(newVal) {},
    weixinisShow: function(newVal) {}
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.contact-widget {
  position: fixed;
  right: 130px;
  bottom: 30px;
  width: 110px;
  height: 50px;
  z-index: 999;
  background-color: #f3f3f9;
  border-radius: 999rem;
}
.contact-widget-circle {
  position: fixed;
  right: 130px;
  bottom: 30px;
  width:  50px;
  height: 50px;
  z-index: 997;
  background-color: #f3f3f9;
  border-radius: 999rem;
}

.consult_item {
  margin: 6%;
}
.qqgroup {
  position: fixed;
  right: 163px;
  bottom: 70px;
  text-align: center;
  border-radius: 2px;
  z-index: 999;
}
.weixingroup {
  position: fixed;
  right: 110px;
  bottom: 80px;
  text-align: center;
  border-radius: 2px;
  z-index: 999;
}

.chat-widget {
  right: 60px;
  width: 50px;
  height: 50px;
}
.chat-widget .consult_item {
  margin: 10% 0 0 6%;
}

  @media (max-width: 768px) {
    .contact-widget-circle {
        width: 40px;
        height: 40px;
        bottom: 0px;
        right: 70px;
        
    }
    .mobileImg {
        margin-left: 3px !important;
        margin-top: 3px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FloatingWindow.vue